module.exports = __webpack_public_path__ + "img/magnum-recept-01.2400c067.png";